module.exports = __WEBPACK_EXTERNAL_MODULE_260__;


//////////////////
// WEBPACK FOOTER
// external "History"
// module id = 260
// module chunks = 1